<script lang="ts">
	import Description from '$lib/components/SEO/Description.svelte';
	import Title from '$lib/components/SEO/Title.svelte';
	import NewHomeCreditSimulation from '$lib/components/Simulations/Components/Products/NewHomeCreditSimulation.svelte';
	import PersonalCredit from '$lib/components/Simulations/Components/Products/PersonalCreditSimulation.svelte';
	import __ from '$lib/stores/TranslationStore';
</script>

<svelte:head>
	<Title
		content={$__(
			'Simulador de Crédito Habitação: Encontre a Melhor Solução com Poupança no Minuto'
		)}
	/>
	<Description
		content={$__(
			'Utilize o nosso simulador de crédito habitação para descobrir a solução mais vantajosa para a compra da sua casa. A Poupança no Minuto ajuda-o a comparar opções e a escolher o crédito à medida das suas necessidades. Comece já a planear o seu futuro com confiança.'
		)}
	/>
</svelte:head>

<NewHomeCreditSimulation />
